import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';

@Component({
  selector: 'app-p0003606-card-injection-ph-statut',
  templateUrl: './p0003606-card-injection-ph-statut.component.html',
  styleUrls: ['./p0003606-card-injection-ph-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P0003606CardInjectionPhStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P0003606.dashboard.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P0003606.dashboard.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttonMode = [
      {
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.INJECTION_PH,
      FunctionOnglet.CONTROL,
      this.translateService.instant('P0003606.dashboard.ph'),
    );
  }
}
